import React, { useEffect } from "react";
import SimpleBar from "simplebar-react";
import ReactDOM from "react-dom";
import "choices.js/public/assets/styles/choices.min.css";
import { Link } from "react-router-dom";
import { Col, Row, Button } from "reactstrap";
import { useDispatch } from "react-redux";
import { showRightSidebarAction } from "../../store/actions";

const SimpleBarFilterCustom = ({
  children = <></>,
  isOpen = false,
  width = 390,
  disabledClearFilter = false,
  onClose = () => {},
  onClearFilter = () => {},
  onSubmit = () => {},
}) => {
  // eslint-disable-next-line
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(showRightSidebarAction(isOpen));
  }, [isOpen]);

  // Lock/unlock body scroll while the right sidebar is open
  useEffect(() => {
    if (isOpen) {
      const scrollY = window.scrollY || document.documentElement.scrollTop || 0;
      document.body.style.position = "fixed";
      document.body.style.top = `-${scrollY}px`;
      document.body.style.width = "100%";
      document.body.style.overflow = "hidden";
    } else {
      const top = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.width = "";
      document.body.style.overflow = "";
      if (top) {
        const y = -parseInt(top, 10) || 0;
        window.scrollTo(0, y);
      }
    }
  }, [isOpen]);

  return (
    <React.Fragment>
      <div
        style={{ width: width, display: isOpen ? "block" : "none" }}
        className="right-bar bg-info right-bar-custom-filter"
        id="right-bar"
      >
        <SimpleBar className="h-100 d-flex">
          <div className="d-flex w-100 flex-column px-3">
            <div className="rightbar-title d-flex align-items-center justify-content-between pt-4 pb-1">
              <span className="text-primary-dark font-size-24 fw-bold">
                Filtros
              </span>
              <Link
                to="#"
                className="float-end d-flex align-items-center gap-2"
                onClick={() => onClose()}
              >
                <span className="font-size-12">Recolher</span>
                <i className="fas fa-angle-right"></i>
              </Link>
            </div>
            <div className="rightbar-title pb-2">
              <button
                className={`tn text-dark font-size-12 ${
                  disabledClearFilter ? "disabled" : ""
                }`}
                onClick={() => onClearFilter()}
              >
                <i className="fas fa-times"></i>
                Limpar Filtros
              </button>
            </div>
            <div className="flex-grow-1 content-filters">{children}</div>
            <hr className="mt-1" />
            <div>
              <Row className="mb-3">
                <Col md={12} className="container-button-submit">
                  <Button
                    type="button"
                    onClick={() => onSubmit()}
                    className="btn btn-primary w-100"
                  >
                    Aplicar Filtros
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </SimpleBar>
      </div>
      {isOpen &&
        ReactDOM.createPortal(
          <div className="rightbar-overlay" onClick={() => onClose()}></div>,
          document.getElementById("layout-wrapper")
        )}
    </React.Fragment>
  );
};

export default SimpleBarFilterCustom;
